
<div class="phone-input" [formGroup]="formGroup">
    <span class="prefix">+</span>
    <input matInput type="number" class="country" formControlName="codigoPais" (input)="onChange(value)" autocomplete="off">
    <span class="separator">-</span>
    <input matInput type="number" class="area" formControlName="codigoArea" (input)="onChange(value)" autocomplete="off">
    <span class="separator">-</span>
    <input matInput type="number" class="number" formControlName="numero" (input)="onChange(value)" autocomplete="off">
</div>
